import { IconDollar } from '@/presentation/components/icons';
import React from 'react';
import Styles from './list-styles.scss';
const Plan = ({ title: globalTitle, items }) => {
    return (React.createElement("div", null,
        React.createElement("div", { className: Styles.listWrap },
            React.createElement("div", { className: Styles.titleWrap },
                React.createElement("div", { style: { padding: '0.5rem' } },
                    React.createElement(IconDollar, null)),
                React.createElement("div", { className: Styles.title }, globalTitle))),
        React.createElement("div", { className: Styles.itemsWrap },
            React.createElement("ul", null, items.map(({ title, subtitle, price, detail, backgroundColor }, key) => (React.createElement("li", { key: `${title}_${key}`, style: { backgroundColor: backgroundColor || 'inherit' } },
                React.createElement("div", { className: Styles.leftPart },
                    React.createElement("div", { className: Styles.title }, title),
                    React.createElement("div", { className: Styles.subtitle }, subtitle)),
                React.createElement("div", { className: Styles.rightPart },
                    React.createElement("div", { className: Styles.price }, price),
                    React.createElement("div", { className: Styles.detail }, detail)))))))));
};
export default Plan;
